import React from 'react';
import clsx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core';
import ChatWindow from '../ChatWindow/ChatWindow';
import ParticipantList from '../ParticipantList/ParticipantList';
import MainParticipant from '../MainParticipant/MainParticipant';
import useChatContext from '../../hooks/useChatContext/useChatContext';
// import CaptionText from '../CaptionText/CaptionText';
import CaptionTextFinal from '../CaptionTextFinal/CaptionTextFinal';
import CaptionIBM from '../CaptionIBM/CaptionIBM';

const useStyles = makeStyles((theme: Theme) => {
  const totalMobileSidebarHeight = `${theme.sidebarMobileHeight +
    theme.sidebarMobilePadding * 2 +
    theme.participantBorderWidth}px`;
  return {
    container: {
      position: 'relative',
      height: '100%',
      display: 'grid',
      gridTemplateColumns: `1fr ${theme.sidebarWidth}px`,
      gridTemplateRows: '100%',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: `100%`,
        gridTemplateRows: `calc(100% - ${totalMobileSidebarHeight}) ${totalMobileSidebarHeight}`,
      },
    },
    chatWindowOpen: { gridTemplateColumns: `1fr ${theme.sidebarWidth}px ${theme.chatWindowWidth}px` },
  };
});

export default function Room() {
  const classes = useStyles();
  const { isChatWindowOpen } = useChatContext();
  const chatEnabled = process.env.REACT_APP_DISABLE_TWILIO_CONVERSATIONS !== 'true';
  const hideRecording = process.env.REACT_APP_HIDE_RECORDING === 'true';
  return (
    <div className={clsx(classes.container, { [classes.chatWindowOpen]: chatEnabled && isChatWindowOpen })}>
      <MainParticipant />
      {!hideRecording && <CaptionTextFinal />}
      {/*<CaptionIBM />*/}
      <ParticipantList />
      {/*<ChatWindow />*/}
    </div>
  );
}
